import React from 'react';
import Typography from '@mui/material/Typography';
import Aux from '../../../hoc/Auxilary/Auxilary';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AddButton from '@mui/icons-material/AddBoxTwoTone';
import Divider from '@mui/material/Divider';

export default function SubSectionHeading(props) {
  const add = props.add ?? false;
  const disabled = props.addSecurity ?? false;
  return (
    <Aux>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          fontSize: { xs: '1.1rem', sm: '1.25rem' },
          letterSpacing: '-0.005em',
          lineHeight: 1.3,
          display: 'inline-block',
        }}
      >
        {props.title}
      </Typography>
      {(add && !disabled) &&
        <Tooltip title={props.addTitle} placement='right'>
            <IconButton aria-label={props.addTitle} onClick={() => add()}>
                <AddButton color="primary" />
            </IconButton>
        </Tooltip>
      }
      <Divider sx={{ mt: 0.5, mb: 1, borderColor: 'divider' }}/>
    </Aux>
  );
}
